__webpack_require__.p = "https://hybrid-cloud-widgets-production.s3.us.cloud-object-storage.appdomain.cloud/";